import styled from 'styled-components';
 
export const OrganizationsWrapper = styled.div`
padding:50px 0;
 @media screen and (max-width:1199px) {
     padding-top:200px;
   }
   @media screen and (max-width:991px) {
     padding-top:174px;
   }
   p{
       color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    margin-bottom: 15px;
    }
    h1{
        color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: 700;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 20px;}
      .search-header{
      display: flex;
      align-items: center;
      background: #fff;
      box-shadow: 0px 20px 20px #0000001A;
      border-radius: 10px;
      padding:6px;
      max-width: 680px;
      width: 100%;
      justify-content: space-between;
    .input-group {
       @media screen and (max-width:480px) {
          width: 100%;
}
      }
      @media screen and (max-width:767px) {
        flex-wrap: wrap;
         margin-bottom: 20px;
         gap: 12px;
      }
      
      @media screen and (max-width:480px) {
       justify-content: flex-end;
        padding: 9px !important;
      }
     
      .zipcode{
          max-width: 150px;          
        .form-control{
          padding-left: 20px !important;
        }          
          &:after {
              background: #333333;
              position: absolute;
              width: 1px;
              height: 40px;
              content: "";
              top: -5px;
              // @media screen and (max-width:480px) {
              //       display:none;
              // }
          }
      }
    
      .input-group{
          width: auto;
        
          .form-control{
              border: none;
              padding-top: 2px;
              padding-bottom: 2px;
              font-family: "Jost", sans-serif;
              font-size: 18px;
              font-weight: 500;
              line-height: 26px;
              padding-left: 0px;
              @media screen and (max-width:767px) { 
                font-size: 16px;
                line-height: 25px;
              }
              &:focus{
                  background: transparent !important;
              }
              &::-webkit-input-placeholder { 
                    color: #333333;
                  }
              &::-moz-placeholder { 
                  color: #333333;
                  }
              &:-ms-input-placeholder { 
                  color: #333333;
                  }
              &:-moz-placeholder { 
                  color: #333333;
              }
          }
      }
      .btn-outline-success{
          background: #01606F;
          border: none;
          color: #fff;
          font-family: "Jost", sans-serif;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          padding: 12px 40px;
          transition: all 0.5s;
          @media screen and (max-width:767px) {
            padding: 8px 20px;
          }
          &:hover{
              background: #FFD495;
              color: #333333;
              transition: all 0.5s;
          }
      }
  }
.zip-code-box {
   width: 100% !important;
    padding: 10px !important;
    font-size: 15px !important;
    font-weight: 400 !important;
    border-left: 1px solid #000 !important;
}
.red-alert-text{
        background-color: #f2dede;
        border-color: #ebccd1;
        color: #a94442;
        padding: 14px 32px;
       p{
         margin:0;
          color: #a94442;
       } 
    }
  .greent-text{
    background-color: #dff0d8;
    border-color: #d6e9c6;
    color: #3c763d;
    padding: 14px 32px;
    p{
       margin:0;
       color: #3c763d;
      } 
  }     
`;
 